import React from "react";

function Notice() {
  return (
    <>
      <div className='section-notice'>
        <div className='container-1440'>
          <div className='row'>
            <div className='col-lg-12'></div>
            <h1>Notice!</h1>
            <p>
              Room not found / May be version mismatch / room already starteds
            </p>
            <button className='okay-btn'>OK</button>
          </div>
        </div>
      </div>
    </>
  );
}
export default Notice;
